<template>
    <div :id="$t('label.vehicle')">
        <canvas ref="canvas" width="900" height="400"></canvas>
    </div>
</template>

<script>
import { Bar, mixins} from 'vue-chartjs'
const {reactiveProp} = mixins

export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: ['chartData','options'],
    data() {
        return {
            
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>